import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mhistory',
  templateUrl: './mhistory.component.html',
  styleUrls: ['./mhistory.component.css']
})
export class MhistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
